import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { useTitleDispatch } from '../TitleContextProvider';
import BSearch from './BSearch';
import i18n from 'i18next';

const REVEAL = 'ceres-bsearch-fadeup 360ms cubic-bezier(.2,.65,.2,1)';

const BSearchContainer = ({ buildingNum, id, t }) => {
  const dispatch = useTitleDispatch();
  const hasBuilding = Boolean(buildingNum || id);

  useEffect(() => {
    dispatch({
      pageTitle: t('building.generic.search.for.a.building.label'),
    });
  }, [i18n.language]);

  // Building loaded — compact inline search, no hero chrome.
  if (hasBuilding) return <BSearch compact />;

  return (
    <Box
      sx={{
        pt: { xs: 6, md: 9 },
        pb: 2,
        maxWidth: 640,
        mx: 'auto',
        textAlign: 'center',
        '@keyframes ceres-bsearch-fadeup': {
          from: { opacity: 0, transform: 'translateY(8px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
        '@media (prefers-reduced-motion: reduce)': {
          '& *': { animation: 'none !important' },
        },
      }}
    >
      <Box
        component="h1"
        sx={{
          m: 0,
          mb: 2.5,
          fontSize: { xs: 17, md: 22 },
          fontWeight: 400,
          lineHeight: 1.15,
          letterSpacing: '-0.01em',
          color: '#0c0c0c',
          animation: `${REVEAL} 40ms both`,
        }}
      >
        {t('building.generic.search.for.a.building.label')}
      </Box>
      <Box
        sx={{
          mx: 'auto',
          maxWidth: 560,
          animation: `${REVEAL} 120ms both`,
        }}
      >
        <BSearch />
      </Box>
    </Box>
  );
};

export default withTranslation()(BSearchContainer);
